import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import OpenEye from 'assets/icons/open-eye-icon.svg';
import CloseEye from 'assets/icons/close-eye-icon.svg';

import api from 'services/api';

import { Container } from './_revenueTag';
import { ensureCurrency } from 'utils/format';

export const RevenueTag = () => {
  const [balance, setBalance] = useState<string>()

  const [showAmount, setShowAmount] = useState(false)

  const toggleView = () => {
    setShowAmount(prevState => !prevState)
  }

  const ensureBalance = async () => {
    try {
      const response: any = await api.get('/providers/balance')

      const amount = ensureCurrency((response?.data?.balance?.available?.amount / 100).toString() || '0')

      setBalance(amount);
    } catch (error: any) {
      toast.error(error?.response?.data?.error || 'Opps algo deu errado, tente novamente mais tarde!')
    }
  }

  useEffect(() => {
    ensureBalance()
  },[])

  return (
    <Container>
      <div className="tag__cash-coin" />

      <div className="tag__revenue">
        Seus ganhos
        <span className="tag__revenue__value">{showAmount ? balance : 'R$ _ _ _'}</span>
      </div>

      <button
            type="button"
            className={
              "tag__revenue__view-button"
              + (showAmount
                ? ''
                : '--closed'
              )
            }
            onClick={toggleView}
          >
            <img
              src={showAmount ? OpenEye : CloseEye}
              alt="View value"
              className="tag__revenue-content__view"
            />
          </button>
    </Container>
  );
};
